module.exports = __webpack_public_path__ + "static/media/alpha-foods.56cf39f5.png";